const NO_ITEM = { text: 'No' }
export default NO_ITEM
